import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';

export default class Purchased extends React.Component {
  componentWillMount() {
    document.body.classList.add('white-background');
  }

  componentWillUnmount(){
    document.body.classList.remove('white-background');
  }

  render() {

    return (
      <Container align="center" className='text-page'>
        <Row>
          <p>Purchased!</p>
        </Row>
      </Container>
    )
  }
}
